import * as Yup from 'yup';
import { includes } from 'lodash';
import { DOCUMENT_TYPE, MIN_DOCUMENT_NUMBER } from '../constants';
import getArmenianPassportsValidation from '../helpers/armenianPassportsValidationHelper';
import { isArmenianCountry } from '../helpers/countryHelper';

// eslint-disable-next-line func-names
Yup.addMethod(Yup.array, 'unique', function (message, path) {
  // eslint-disable-next-line func-names
  return this.test('unique', message, function (list) {
    const duplicates = list
      .map((r) => r[path])
      .filter((value, index, self) => self.indexOf(value) !== index);
    if (!duplicates.length) {
      return true;
    }
    // find first duplicated.
    list.forEach((row, index) => {
      if (includes(duplicates, row[path])) {
        throw this.createError({
          path: `${this.path}[${index}].${path}`,
          value: row[path],
          params: row,
          message,
        });
      }
    });
    return true;
  });
});

// eslint-disable-next-line func-names
Yup.addMethod(Yup.string, 'isCorrectLanguage', function () {
  // eslint-disable-next-line func-names
  const languageValidations = {
    /* eslint-disable no-useless-escape */

    /* if you forget to put the "-" symbol at the very end of [],
        this regex will be interpreted as a range. hence better to always escape it */
    hy: {
      regex: /^[աբգդեզէըթժիլխծկհձղճմյնշոչպջռսվտրցւփքօֆևԱԲԳԴԵԶԷԸԹԺԻԼԽԾԿՀՁՂՃՄՅՆՇՈՉՊՋՌՍՎՏՐՑՒՓՔՕՖ0-9_. ։:,()/\-․֊«»<>―՞\?՝`~՜՛'"\s]*$/,
      errorMessage: 'validationErrors.onlyArmenian',
    },
    en: {
      regex: /^[a-zA-Z0-9_. ։:,()/\-․֊«»<>―՞\?՝`~՜՛'"\s]*$/,
      errorMessage: 'validationErrors.onlyEnglish',
    },
    ru: {
      regex: /^[аАбБвВгГдДеЕёЁжЖзЗиИйЙкКлЛмМнНоОпПрРсСтТуУфФхХцЦчЧшШщЩъЪыЫьЬэЭюЮяЯ0-9_. ։:,()/\-․֊«»<>―՞\?՝`~՜՛'"\s]*$/,
      errorMessage: 'validationErrors.onlyRussian',
    },
    /* eslint-enable no-useless-escape */
  };

  return this.when('formLanguage', (formLanguage, schema) => {
    if (!formLanguage) {
      return schema;
    }
    const { regex, errorMessage } = languageValidations[formLanguage];
    return schema.matches(regex, errorMessage);
  });
});

// eslint-disable-next-line func-names
Yup.addMethod(Yup.string, 'isArmenianPassportsValidation', function () {
  return this.when(['citizenship', 'documentType'], (citizenship, documentType, schema, input) => {
    if (!documentType) {
      return schema;
    }
    if (!isArmenianCountry(citizenship)) {
      return schema.min(MIN_DOCUMENT_NUMBER, 'validationErrors.minDocNumber');
    }
    if (documentType.id === DOCUMENT_TYPE.PASSPORT && input.value) {
      return getArmenianPassportsValidation(input.value, schema);
    }
    return schema;
  });
});

export default Yup;
